import { getAuthenticatedUser, getTokenFromAuthenticatedUser } from 'src/features/login';

export const generateAuthHeader = async () => {
    const user = await getAuthenticatedUser();
    const token = getTokenFromAuthenticatedUser(user);

    return { Authorization: `Bearer ${token}` };
};
